import { render, staticRenderFns } from "./BDXEditFormContinuousContract.vue?vue&type=template&id=79564846"
import script from "./BDXEditFormContinuousContract.vue?vue&type=script&lang=js"
export * from "./BDXEditFormContinuousContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports